<!--table headers-->
<div class="col-xs-12">
    <div class="row">
        <div *ngFor="let column of tableColumns" class="{{ column[2] }} header" (click)="sort(column);">
            <ng-container *ngIf="column[3] === 'name'">
                <span [ngClass]="{'sorted': sortIsActivated && sortedColumn === column[0] + itemLanguage, 'asc': order === 'asc', 'desc': order === 'desc'}">
                    {{ column[1] | translate }} {{ itemLanguage }}
                </span>
            </ng-container>
            <ng-container *ngIf="column[3] !== 'name'">
                <span [ngClass]="{'sorted': sortIsActivated && sortedColumn === column[0], 'asc': order === 'asc', 'desc': order === 'desc'}">
                    {{ column[1] | translate }}
                </span>
            </ng-container>
        </div>
    </div>
</div>
